// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c5f68727","351":"bb91a1da","511":"721461f8","681":"0fbd97eb","774":"023796fa","863":"026b258c","895":"968b1137"}[chunkId] + ".chunk.js";
};